import {getTestProps} from '@benchling/js-test-utils';
import React, {useState} from 'react';

import {
  BasesColumnConfig,
  BasesColumnEntityType,
  getBasesColumnConfigDisplayName,
} from 'notebook/structured-tables/bases-columns/BasesColumnConstants';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import InputWrapper from 'ui-library/inputs/InputWrapper';
import ModalAnchor from 'ui-library/ModalAnchor';
import {ExpandableModal} from 'ui-library/modals/ExpandableModal';
import * as keyboard from 'util/Keyboard';

export interface EditSequenceBasesModalProps {
  initialValue?: string;
  basesColumnConfig: BasesColumnConfig;
  onRequestSubmit: (bases: string) => void;
  cid: string;
}

export function EditSequenceBasesModal({
  initialValue,
  basesColumnConfig,
  onRequestSubmit,
  cid,
}: EditSequenceBasesModalProps): JSX.Element {
  const [basesValue, setBasesValue] = useState(initialValue ?? '');
  const [onRequestCloseValue] = useState(initialValue ?? ''); // required to circumvent bug upon closing
  return (
    <ExpandableModal
      onRequestClose={() => {
        onRequestSubmit(onRequestCloseValue);
      }}
      onRequestSubmit={() => {
        onRequestSubmit(basesValue);
      }}
      startMaximized={false}
      title="Edit sequence"
      buttons={[{submit: true, text: 'Save'}]}
    >
      <InputWrapper
        id="basesInput"
        label={getBasesColumnConfigDisplayName(basesColumnConfig)}
        labelStyle={FieldLabel.STYLES.LABEL}
      >
        <textarea
          data-cid={cid}
          name="Bases"
          value={basesValue.replace(/\s+/g, '')}
          onChange={(e) => {
            setBasesValue(e.target.value.replace(/\s+/g, ''));
          }}
          onKeyDown={(e: React.KeyboardEvent<HTMLTextAreaElement>) => {
            if (keyboard.isEnterKey(e)) {
              e.preventDefault();
              onRequestSubmit(basesValue);
            }
          }}
          autoFocus={true}
          onFocus={(e) => {
            e.target.select();
          }}
          rows={4}
          {...getTestProps({component: 'EditSequenceBasesModal', element: 'basesInput'})}
          placeholder={`Enter ${
            basesColumnConfig.entityType === BasesColumnEntityType.AA_SEQUENCE ? 'residues' : 'bases'
          }...`}
        />
      </InputWrapper>
    </ExpandableModal>
  );
}

export default function EditSequenceBasesModalWithAnchor(props: EditSequenceBasesModalProps): JSX.Element {
  return (
    <ModalAnchor open={true}>
      <EditSequenceBasesModal {...props} />
    </ModalAnchor>
  );
}
